<div class="my-feedback-detail">
	<div class="mb-4 flex items-start justify-between gap-4">
		<div>
			<div class="text-base font-bold text-black">View Feedback</div>
			@if (response) {
				@if (showTemplateName) {
					<div class="mt-1 text-sm text-grey-60">{{ response.template?.name || "-" }}</div>
				}
				@if (response.isTied) {
					<div class="mt-1 text-sm text-grey-60">
						Form: {{ response.formName || "-" }} | Type: {{ response.formTypeLabel || "-" }} | Instructor:
						{{ response.instructorName || "-" }}
					</div>
				}
			}
		</div>
		<div class="text-sm text-red">
			<a class="cursor-pointer hover:underline" [routerLink]="['/' + routeType.MY_FEEDBACK]">{{ listLabel }}</a>
			<span class="mx-1">&gt;</span>
			<span>View</span>
		</div>
	</div>

	@if (response) {
		<div class="flex flex-col gap-4">
			@for (question of pagedQuestions; track question.id; let i = $index) {
				<div class="rounded border border-[#CFE3FF] p-4">
					<p class="mb-3 font-semibold">Question {{ questionNumber(i) }}</p>
					<p class="mb-4 whitespace-pre-wrap">{{ question.prompt }}</p>
					@if (needsRating(question)) {
						<div class="mb-3 text-sm font-medium">Rating:</div>
						<div class="mb-4">
							<app-feedback-rating-scale
								[selected]="answerFor(question.id)?.rating ?? null"
								[readonly]="true"
							></app-feedback-rating-scale>
						</div>
					}
					@if (needsAnswer(question)) {
						<div class="mb-2 text-sm font-medium">Answer:</div>
						<div class="rounded bg-grey-10 p-3 text-sm text-grey-60">
							{{ answerFor(question.id)?.remarks || "-" }}
						</div>
					}
				</div>
			}
		</div>

		@if (totalPages > 1) {
			<div class="mt-6 flex items-center justify-center gap-4 text-sm">
				<button
					class="aa-btn"
					data-variant="tertiary"
					data-size="small"
					[disabled]="pageIndex === 0"
					(click)="prevPage()"
				>
					&lt;
				</button>
				@for (page of pageNumbers; track page) {
					<button
						type="button"
						class="h-8 w-8 rounded-full border text-sm"
						[class.bg-red-600]="pageIndex === page"
						[class.text-white]="pageIndex === page"
						(click)="pageIndex = page"
					>
						{{ page + 1 }}
					</button>
				}
				<span>Page {{ pageIndex + 1 }} of {{ totalPages }} ({{ questions.length }} questions)</span>
				<button
					class="aa-btn"
					data-variant="tertiary"
					data-size="small"
					[disabled]="pageIndex >= totalPages - 1"
					(click)="nextPage()"
				>
					&gt;
				</button>
			</div>
		}

		<div class="mt-6">
			<button type="button" class="aa-btn" data-variant="secondary" data-size="small" (click)="back()">Back</button>
		</div>
	}
</div>
